<template>
  <w-icon-wrapper
    :height='24'
    :width='24.003'
    icon-name='work-export-icon'
    view-box='0 0 24.003 24'
  >
    <path
      id='Pfad_55721'
      d='M23,8.333a1,1,0,0,0-1,1V22H2V2H14.666a1,1,0,0,0,0-2H0V24H24V9.333A1,1,0,0,0,23,8.333Z'
      data-name='Pfad 55721'
      fill='currentColor'
    />
    <path
      id='Pfad_55722'
      d='M18.656,2.1l1.831.012L9.876,12.42a.991.991,0,1,0,1.381,1.421l10.6-10.3-.075,1.846a.975.975,0,0,0,.962,1.019,1.033,1.033,0,0,0,1.043-.986L24,.13,23.018.124a.991.991,0,0,0-.109,0L18.717.1a1.029,1.029,0,0,0-1.033.995A.974.974,0,0,0,18.656,2.1Z'
      data-name='Pfad 55722'
      fill='currentColor'
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconExport' };
</script>
